import { render, staticRenderFns } from "./VideoPromocional.vue?vue&type=template&id=a273cab6&scoped=true&"
import script from "./VideoPromocional.vue?vue&type=script&lang=js&"
export * from "./VideoPromocional.vue?vue&type=script&lang=js&"
import style0 from "./VideoPromocional.vue?vue&type=style&index=0&id=a273cab6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a273cab6",
  null
  
)

export default component.exports